import { useCallback } from 'react';
import { ISegmentFilter } from 'sections/offsite-campaigns/entities/offsiteCampaign';
import { useOffsiteCampaignEditorDispatch } from 'sections/offsite-campaigns/offsite-campaign-editor/context/UseOffsiteCampaignEditorContext';

export const useRemoveSegmentFilter = (segmentId: string, segmentFilter: ISegmentFilter) => {
  const dispatch = useOffsiteCampaignEditorDispatch();

  return useCallback(() => {
    dispatch({
      type: 'REMOVE_SEGMENT_FILTER',
      payload: {
        segmentId: segmentId,
        segmentFilterId: segmentFilter.id,
      },
    });
  }, [dispatch, segmentFilter.id, segmentId]);
};
